export default {
  SET_playbackItem(state, value) {
    state.playbackItem = value;
  },
  SET_playbackItems(state, value) {
    state.playbackItems = value;
  },
};
